import { DialogService, GridAction } from '@eforall/dashboard';
import { DialogMode, GoalsAndProgress } from '@interfaces';
import { GoalDetailsDialog, GoalEditorDialog, GoalEditorDialogData } from '../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';

export function getActions(dialogService: DialogService, areaService: AcceleratorAreaService) {

	const actions: GridAction<GoalsAndProgress>[] = [
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'View Goal',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(GoalDetailsDialog, { data: { accGoalId: rows[0]!.accGoalId } }, 700, 700);
				await areaService.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Edit Goal',
			isEnabled: rows => areaService.canEdit() && !!rows.length,
			execute: async rows => {
				const r = rows[0]!;
				const dialogData: GoalEditorDialogData = {
					mode: DialogMode.EDIT,
					accGoalId: r.accGoalId,
					ventureName: r.ventureName,
				};
				await dialogService.showCustom<GoalEditorDialog, GoalEditorDialogData>(GoalEditorDialog, { data: dialogData }, 650, 650);
				await areaService.reloadData();
			}
		},
	];

	return actions;
}